<ng-container *ngIf="milestonePermissionsService.canUpdateMilestoneStatus(milestone(), project()); else disabledStatus">
  <oes-dropdown
    [ngClass]="dropdownColor"
    class="style-overhaul-flag sm"
    [items]="statusDropdownOptions()"
    [initialSelections]="initialStatusSelection()"
    [enableSearch]="false"
    [required]="true"
    [selection]="'single'"
    (click)="stopPropagation($event)"
    (selectionChanged)="statusChanged.emit($event)">
  </oes-dropdown>
</ng-container>

<ng-template #disabledStatus>
  <span class="status" [ngClass]="mapStatusToClass">
    {{ initialStatusSelection()?.[0]?.name }}
  </span>
</ng-template>
